@if (loading) {
  <div class="loading-container">
    <mat-progress-bar mode="indeterminate" class="custom-progress"></mat-progress-bar>
  </div>
}

@if (!loading) {
  <div class="container-fluid py-4 main-container fade-in">
    @if (surveyQuestionHistories?.length) {
      <div class="questions-list">
        @for (history of surveyQuestionHistories; track history; let i = $index) {
          <div class="mb-4">
            <app-question-history-dashboard [questionHistory]="history"></app-question-history-dashboard>
          </div>
        }
      </div>
      <mat-paginator
        class="mt-5 paginator-rounded"
        (page)="onPageChange($event)"
        [length]="totalSurveyQuestionHistories"
        [pageIndex]="currentPageIndex"
        [pageSizeOptions]="[1, 5, 10]"
        [pageSize]="pageSize"
        aria-label="Select page">
      </mat-paginator>
    } @else {
      <div class="empty-state d-flex flex-column align-items-center justify-content-center p-5 text-center">
        <div class="icon-circle mb-3">
          <mat-icon>inbox</mat-icon>
        </div>
        <h5 class="text-dark font-weight-bold">Nessuna cronologia trovata</h5>
        <p class="text-muted">
          {{ "components.surveys.question-history-dashboard.no-question-history" | translate }}
        </p>
      </div>
    }
  </div>
}
